module.exports = __webpack_public_path__ + "media/backgrounds/marek-piwnicki-G3msBI-g1sI-unsplash-dd618f79.jpg";